module.exports = __webpack_public_path__ + "img/107ne.e7b78d23.svg";